export const enum ContextType {
    none = "none",
    messageRead = "message-read",
    messageCompose = "mesage-compose",
}
